import { ReactComponent as edit } from "../assets/icon/Path.svg"
import { ReactComponent as Delete } from "../assets/icon/trash-2.svg"
export const data = [
    {
        id: 1,
        uz: "Burger uz",
        eng: "Burger eng",
        main: "Burger",
        Edit: edit,
        Delete: Delete
    },
    {
        id: 2,
        uz: "Lavash uz",
        eng: "Lavash eng",
        main: "Lavash",
        Edit: edit,
        Delete: Delete
    }, {
        id: 3,
        uz: "Hot Drinks uz",
        eng: "Hot Drinks eng",
        main: "Drinks",
        Edit: edit,
        Delete: Delete
    }, {
        id: 4,
        uz: "Cold Drinks uz",
        eng: "Cold Drinks eng",
        main: "Drinks",
        Edit: edit,
        Delete: Delete
    }, {
        id: 5,
        uz: "Other Drinks uz",
        eng: "Other Drinks eng",
        main: "Drinks",
        Edit: edit,
        Delete: Delete
    },
]
